var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.5 4a8.5 8.5 0 1 1 0 17 8.5 8.5 0 0 1 0-17m2.808 4.85H9.692a.84.84 0 0 0-.842.842v5.616c0 .465.377.842.842.842h5.616a.84.84 0 0 0 .842-.842V9.692a.84.84 0 0 0-.842-.842m-4.98 3.088q-.072.27-.074.562a2.246 2.246 0 0 0 4.492 0q-.002-.292-.074-.562h.636v3.09a.28.28 0 0 1-.28.28H9.972a.28.28 0 0 1-.281-.28v-3.09Zm2.172-.842a1.404 1.404 0 1 1 0 2.808 1.404 1.404 0 0 1 0-2.808m2.527-1.404a.28.28 0 0 1 .281.28v.843a.28.28 0 0 1-.28.281h-.843a.28.28 0 0 1-.28-.281v-.842a.28.28 0 0 1 .28-.28Z"
  })));
};
export default SvgInstagram;